const MARKET_SERVICE = process.env.VUE_APP_MARKET_SERVICE

const tradeInsuranceRouter = {
  path: '/',
  redirect: '/tradeInsurance',
  component: () => import('@/layout'),
  children: [
    {
      path: 'tradeInsurance', // 贸易保险
      name: 'tradeInsurance',
      redirect: 'tradeInsurance/tradeInsuranceHome',
      component: () =>
        import(/* webpackChunkName: "trade-insurance" */ '@/pages/tradeInsurance/home'),
      children: [
        {
          path: 'tradeInsuranceHome', // 贸易保险保险详情
          component: () =>
            import(/* webpackChunkName: "trade-insurance" */ '@/pages/tradeInsurance/home/home'),
          meta: {
            title: '贸易保险保险详情',
            breadcrumb: {
              name: '首页',
              path: '/',
              isOut: false,
              children: {
                name: '服务专区',
                path: MARKET_SERVICE,
                isOut: true,
                children: {
                  name: '贸易保险',
                  path: '/exportInsurance/index',
                  isOut: false,
                  children: {
                    name: '其他保险产品',
                    path: '',
                    isOut: false
                  }
                }
              }
            }
          }
        },
        {
          path: 'first', // 中长期出口信用保险
          name: 'first',
          redirect: 'first/first1',
          component: () =>
            import(/* webpackChunkName: "trade-insurance" */ '@/pages/tradeInsurance/first'),
          children: [
            {
              path: 'first1', // 中长期出口信用保险
              name: 'first1',
              meta: {
                title: '中长期出口信用保险',
                type: 'long',
                pageName: '中长期出口信用保险',
                bannerTitle: '中长期出口信用保险',
                bannerDesc:
                  '为金融机构、出口企业或融资租赁公司收回融资协议、商务合同或租赁协议项下应收款项提供风险保障!',
                bannerImg: require('@/assets/tradeInsurance/images/2.png'),
                breadcrumb: {
                  name: '首页',
                  path: '/',
                  isOut: false,
                  children: {
                    name: '服务专区',
                    path: MARKET_SERVICE,
                    isOut: true,
                    children: {
                      name: '贸易保险',
                      path: '/exportInsurance/index',
                      isOut: false,
                      children: {
                        name: '其他保险产品',
                        path: '/tradeInsurance/tradeInsuranceHome',
                        isOut: false,
                        children: {
                          name: '中长期出口信用保险',
                          path: '',
                          isOut: false
                        }
                      }
                    }
                  }
                }
              },
              component: () =>
                import(
                  /* webpackChunkName: "trade-insurance" */ '@/pages/tradeInsurance/first/first1'
                )
            },
            {
              path: 'first2', // 出口买方信贷保险
              name: 'first2',
              meta: {
                title: '出口买方信贷保险',
                type: 'long',
                pageName: '出口买方信贷保险',
                bannerTitle: '中长期出口信用保险',
                bannerDesc:
                  '为金融机构、出口企业或融资租赁公司收回融资协议、商务合同或租赁协议项下应收款项提供风险保障!',
                bannerImg: require('@/assets/tradeInsurance/images/2.png'),
                breadcrumb: {
                  name: '首页',
                  path: '/',
                  isOut: false,
                  children: {
                    name: '服务专区',
                    path: MARKET_SERVICE,
                    isOut: true,
                    children: {
                      name: '贸易保险',
                      path: '/exportInsurance/index',
                      isOut: false,
                      children: {
                        name: '其他保险产品',
                        path: '/tradeInsurance/tradeInsuranceHome',
                        isOut: false,
                        children: {
                          name: '出口买方信贷保险',
                          path: '',
                          isOut: false
                        }
                      }
                    }
                  }
                }
              },
              component: () =>
                import(
                  /* webpackChunkName: "trade-insurance" */ '@/pages/tradeInsurance/first/first2'
                )
            },
            {
              path: 'first3', // 出口卖方信贷保险
              name: 'first3',
              meta: {
                title: '出口卖方信贷保险',
                type: 'long',
                pageName: '出口卖方信贷保险',
                bannerTitle: '中长期出口信用保险',
                bannerDesc:
                  '为金融机构、出口企业或融资租赁公司收回融资协议、商务合同或租赁协议项下应收款项提供风险保障!',
                bannerImg: require('@/assets/tradeInsurance/images/2.png'),
                breadcrumb: {
                  name: '首页',
                  path: '/',
                  isOut: false,
                  children: {
                    name: '服务专区',
                    path: MARKET_SERVICE,
                    isOut: true,
                    children: {
                      name: '贸易保险',
                      path: '/exportInsurance/index',
                      isOut: false,
                      children: {
                        name: '其他保险产品',
                        path: '/tradeInsurance/tradeInsuranceHome',
                        isOut: false,
                        children: {
                          name: '出口卖方信贷保险',
                          path: '',
                          isOut: false
                        }
                      }
                    }
                  }
                }
              },
              component: () =>
                import(
                  /* webpackChunkName: "trade-insurance" */ '@/pages/tradeInsurance/first/first3'
                )
            },
            {
              path: 'first4', // 再融资保险
              name: 'first4',
              meta: {
                title: '再融资保险',
                type: 'long',
                pageName: '再融资保险',
                bannerTitle: '中长期出口信用保险',
                bannerDesc:
                  '为金融机构、出口企业或融资租赁公司收回融资协议、商务合同或租赁协议项下应收款项提供风险保障!',
                bannerImg: require('@/assets/tradeInsurance/images/2.png'),
                breadcrumb: {
                  name: '首页',
                  path: '/',
                  isOut: false,
                  children: {
                    name: '服务专区',
                    path: MARKET_SERVICE,
                    isOut: true,
                    children: {
                      name: '贸易保险',
                      path: '/exportInsurance/index',
                      isOut: false,
                      children: {
                        name: '其他保险产品',
                        path: '/tradeInsurance/tradeInsuranceHome',
                        isOut: false,
                        children: {
                          name: '再融资保险',
                          path: '',
                          isOut: false
                        }
                      }
                    }
                  }
                }
              },
              component: () =>
                import(
                  /* webpackChunkName: "trade-insurance" */ '@/pages/tradeInsurance/first/first4'
                )
            },
            {
              path: 'first5', // 海外融资租赁保险
              name: 'first5',
              meta: {
                title: '海外融资租赁保险',
                type: 'long',
                pageName: '海外融资租赁保险',
                bannerTitle: '中长期出口信用保险',
                bannerDesc:
                  '为金融机构、出口企业或融资租赁公司收回融资协议、商务合同或租赁协议项下应收款项提供风险保障!',
                bannerImg: require('@/assets/tradeInsurance/images/2.png'),
                breadcrumb: {
                  name: '首页',
                  path: '/',
                  isOut: false,
                  children: {
                    name: '服务专区',
                    path: MARKET_SERVICE,
                    isOut: true,
                    children: {
                      name: '贸易保险',
                      path: '/exportInsurance/index',
                      isOut: false,
                      children: {
                        name: '其他保险产品',
                        path: '/tradeInsurance/tradeInsuranceHome',
                        isOut: false,
                        children: {
                          name: '海外融资租赁保险',
                          path: '',
                          isOut: false
                        }
                      }
                    }
                  }
                }
              },
              component: () =>
                import(
                  /* webpackChunkName: "trade-insurance" */ '@/pages/tradeInsurance/first/first5'
                )
            },
            {
              path: 'first6', // 短期出口信用保险
              name: 'first6',
              meta: {
                title: '短期出口信用保险',
                type: 'short',
                pageName: '短期出口信用保险',
                bannerTitle: '短期出口信用保险',
                bannerDesc:
                  '为以信用证、非信用证方式从中国出口的货物或服务提供应收账款收汇风险保障!',
                bannerImg: require('@/assets/tradeInsurance/images/6.png'),
                breadcrumb: {
                  name: '首页',
                  path: '/',
                  isOut: false,
                  children: {
                    name: '服务专区',
                    path: MARKET_SERVICE,
                    isOut: true,
                    children: {
                      name: '贸易保险',
                      path: '/exportInsurance/index',
                      isOut: false,
                      children: {
                        name: '其他保险产品',
                        path: '/tradeInsurance/tradeInsuranceHome',
                        isOut: false,
                        children: {
                          name: '短期出口信用保险',
                          path: '',
                          isOut: false
                        }
                      }
                    }
                  }
                }
              },
              component: () =>
                import(
                  /* webpackChunkName: "trade-insurance" */ '@/pages/tradeInsurance/first/first6'
                )
            },
            {
              path: 'first7', // 出口企业保险产品
              name: 'first7',
              meta: {
                title: '出口企业保险产品',
                type: 'short',
                pageName: '出口企业保险产品',
                bannerTitle: '短期出口信用保险',
                bannerDesc:
                  '为以信用证、非信用证方式从中国出口的货物或服务提供应收账款收汇风险保障!',
                bannerImg: require('@/assets/tradeInsurance/images/6.png'),
                breadcrumb: {
                  name: '首页',
                  path: '/',
                  isOut: false,
                  children: {
                    name: '服务专区',
                    path: MARKET_SERVICE,
                    isOut: true,
                    children: {
                      name: '贸易保险',
                      path: '/exportInsurance/index',
                      isOut: false,
                      children: {
                        name: '其他保险产品',
                        path: '/tradeInsurance/tradeInsuranceHome',
                        isOut: false,
                        children: {
                          name: '出口企业保险产品',
                          path: '',
                          isOut: false
                        }
                      }
                    }
                  }
                }
              },
              component: () =>
                import(
                  /* webpackChunkName: "trade-insurance" */ '@/pages/tradeInsurance/first/first7'
                )
            },
            {
              path: 'first8', // 融资银行保险产品
              name: 'first8',
              meta: {
                title: '融资银行保险产品',
                type: 'short',
                pageName: '融资银行保险产品',
                bannerTitle: '短期出口信用保险',
                bannerDesc:
                  '为以信用证、非信用证方式从中国出口的货物或服务提供应收账款收汇风险保障!',
                bannerImg: require('@/assets/tradeInsurance/images/6.png'),
                breadcrumb: {
                  name: '首页',
                  path: '/',
                  isOut: false,
                  children: {
                    name: '服务专区',
                    path: MARKET_SERVICE,
                    isOut: true,
                    children: {
                      name: '贸易保险',
                      path: '/exportInsurance/index',
                      isOut: false,
                      children: {
                        name: '其他保险产品',
                        path: '/tradeInsurance/tradeInsuranceHome',
                        isOut: false,
                        children: {
                          name: '融资银行保险产品',
                          path: '',
                          isOut: false
                        }
                      }
                    }
                  }
                }
              },
              component: () =>
                import(
                  /* webpackChunkName: "trade-insurance" */ '@/pages/tradeInsurance/first/first8'
                )
            },
            {
              path: 'first9', // 短期出口特险
              name: 'first9',
              meta: {
                title: '短期出口特险',
                type: 'specialShort',
                pageName: '短期出口特险',
                bannerTitle: '短期出口特险',
                bannerDesc:
                  '为中国出口企业提供的、承担其出口商务合同项下因政治风险和商业风险导致的应收账款损失的保险产品，适用于机电产品、成套设备、工程承包、船舶等行业。',
                bannerImg: require('@/assets/tradeInsurance/images/3.png'),
                breadcrumb: {
                  name: '首页',
                  path: '/',
                  isOut: false,
                  children: {
                    name: '服务专区',
                    path: MARKET_SERVICE,
                    isOut: true,
                    children: {
                      name: '贸易保险',
                      path: '/exportInsurance/index',
                      isOut: false,
                      children: {
                        name: '其他保险产品',
                        path: '/tradeInsurance/tradeInsuranceHome',
                        isOut: false,
                        children: {
                          name: '短期出口特险',
                          path: '',
                          isOut: false
                        }
                      }
                    }
                  }
                }
              },
              component: () =>
                import(
                  /* webpackChunkName: "trade-insurance" */ '@/pages/tradeInsurance/first/first9'
                )
            },
            {
              path: 'first10', // 买方违约保险
              name: 'first10',
              meta: {
                title: '买方违约保险',
                type: 'specialShort',
                pageName: '买方违约保险',
                bannerTitle: '短期出口特险',
                bannerDesc:
                  '为中国出口企业提供的、承担其出口商务合同项下因政治风险和商业风险导致的应收账款损失的保险产品，适用于机电产品、成套设备、工程承包、船舶等行业。',
                bannerImg: require('@/assets/tradeInsurance/images/3.png'),
                breadcrumb: {
                  name: '首页',
                  path: '/',
                  isOut: false,
                  children: {
                    name: '服务专区',
                    path: MARKET_SERVICE,
                    isOut: true,
                    children: {
                      name: '贸易保险',
                      path: '/exportInsurance/index',
                      isOut: false,
                      children: {
                        name: '其他保险产品',
                        path: '/tradeInsurance/tradeInsuranceHome',
                        isOut: false,
                        children: {
                          name: '买方违约保险',
                          path: '',
                          isOut: false
                        }
                      }
                    }
                  }
                }
              },
              component: () =>
                import(
                  /* webpackChunkName: "trade-insurance" */ '@/pages/tradeInsurance/first/first10'
                )
            },
            {
              path: 'first11', // 特定合同保险
              name: 'first11',
              meta: {
                title: '特定合同保险',
                type: 'specialShort',
                pageName: '特定合同保险',
                bannerTitle: '短期出口特险',
                bannerDesc:
                  '为中国出口企业提供的、承担其出口商务合同项下因政治风险和商业风险导致的应收账款损失的保险产品，适用于机电产品、成套设备、工程承包、船舶等行业。',
                bannerImg: require('@/assets/tradeInsurance/images/3.png'),
                breadcrumb: {
                  name: '首页',
                  path: '/',
                  isOut: false,
                  children: {
                    name: '服务专区',
                    path: MARKET_SERVICE,
                    isOut: true,
                    children: {
                      name: '贸易保险',
                      path: '/exportInsurance/index',
                      isOut: false,
                      children: {
                        name: '其他保险产品',
                        path: '/tradeInsurance/tradeInsuranceHome',
                        isOut: false,
                        children: {
                          name: '特定合同保险',
                          path: '',
                          isOut: false
                        }
                      }
                    }
                  }
                }
              },
              component: () =>
                import(
                  /* webpackChunkName: "trade-insurance" */ '@/pages/tradeInsurance/first/first11'
                )
            },
            {
              path: 'first12', // 国内贸易信用保险
              name: 'first12',
              meta: {
                title: '国内贸易信用保险',
                type: 'domestic',
                pageName: '国内贸易信用保险',
                bannerTitle: '国内贸易信用保险',
                bannerDesc:
                  '为中国出口企业提供的、承担其出口商务合同项下因政治风险和商业风险导致的应收账款损失的保险产品，适用于机电产品、成套设备、工程承包、船舶等行业。',
                bannerImg: require('@/assets/tradeInsurance/images/5.png'),
                breadcrumb: {
                  name: '首页',
                  path: '/',
                  isOut: false,
                  children: {
                    name: '服务专区',
                    path: MARKET_SERVICE,
                    isOut: true,
                    children: {
                      name: '贸易保险',
                      path: '/exportInsurance/index',
                      isOut: false,
                      children: {
                        name: '其他保险产品',
                        path: '/tradeInsurance/tradeInsuranceHome',
                        isOut: false,
                        children: {
                          name: '国内贸易信用保险',
                          path: '',
                          isOut: false
                        }
                      }
                    }
                  }
                }
              },
              component: () =>
                import(
                  /* webpackChunkName: "trade-insurance" */ '@/pages/tradeInsurance/first/first12'
                )
            },
            {
              path: 'first13', // 海外投资保险
              name: 'first13',
              meta: {
                title: '海外投资保险',
                type: 'overseas',
                pageName: '海外投资保险',
                bannerTitle: '海外投资保险',
                bannerDesc:
                  '为投资者及金融机构因投资所在国发生的征收、汇兑限制、战争及政治暴乱、违约等政治风险造成的经济损失提供风险保障，承保业务的保险期限不超过20年。',
                bannerImg: require('@/assets/tradeInsurance/images/4.png'),
                breadcrumb: {
                  name: '首页',
                  path: '/',
                  isOut: false,
                  children: {
                    name: '服务专区',
                    path: MARKET_SERVICE,
                    isOut: true,
                    children: {
                      name: '贸易保险',
                      path: '/exportInsurance/index',
                      isOut: false,
                      children: {
                        name: '其他保险产品',
                        path: '/tradeInsurance/tradeInsuranceHome',
                        isOut: false,
                        children: {
                          name: '海外投资保险',
                          path: '',
                          isOut: false
                        }
                      }
                    }
                  }
                }
              },
              component: () =>
                import(
                  /* webpackChunkName: "trade-insurance" */ '@/pages/tradeInsurance/first/first13'
                )
            },
            {
              path: 'first14', // 股权
              name: 'first14',
              meta: {
                title: '股权',
                type: 'overseas',
                pageName: '股权',
                bannerTitle: '海外投资保险',
                bannerDesc:
                  '为投资者及金融机构因投资所在国发生的征收、汇兑限制、战争及政治暴乱、违约等政治风险造成的经济损失提供风险保障，承保业务的保险期限不超过20年。',
                bannerImg: require('@/assets/tradeInsurance/images/4.png'),
                breadcrumb: {
                  name: '首页',
                  path: '/',
                  isOut: false,
                  children: {
                    name: '服务专区',
                    path: MARKET_SERVICE,
                    isOut: true,
                    children: {
                      name: '贸易保险',
                      path: '/exportInsurance/index',
                      isOut: false,
                      children: {
                        name: '其他保险产品',
                        path: '/tradeInsurance/tradeInsuranceHome',
                        isOut: false,
                        children: {
                          name: '股权',
                          path: '',
                          isOut: false
                        }
                      }
                    }
                  }
                }
              },
              component: () =>
                import(
                  /* webpackChunkName: "trade-insurance" */ '@/pages/tradeInsurance/first/first14'
                )
            },
            {
              path: 'first15', // 债权
              name: 'first15',
              meta: {
                title: '债权',
                type: 'overseas',
                pageName: '债权',
                bannerTitle: '海外投资保险',
                bannerDesc:
                  '为投资者及金融机构因投资所在国发生的征收、汇兑限制、战争及政治暴乱、违约等政治风险造成的经济损失提供风险保障，承保业务的保险期限不超过20年。',
                bannerImg: require('@/assets/tradeInsurance/images/4.png'),
                breadcrumb: {
                  name: '首页',
                  path: '/',
                  isOut: false,
                  children: {
                    name: '服务专区',
                    path: MARKET_SERVICE,
                    isOut: true,
                    children: {
                      name: '贸易保险',
                      path: '/exportInsurance/index',
                      isOut: false,
                      children: {
                        name: '其他保险产品',
                        path: '/tradeInsurance/tradeInsuranceHome',
                        isOut: false,
                        children: {
                          name: '债权',
                          path: '',
                          isOut: false
                        }
                      }
                    }
                  }
                }
              },
              component: () =>
                import(
                  /* webpackChunkName: "trade-insurance" */ '@/pages/tradeInsurance/first/first15'
                )
            }
          ]
        }
      ]
    }
  ]
}

export default tradeInsuranceRouter
